import React from 'react';
import { FaMinus, FaPlus as FaPlusSolid } from 'react-icons/fa';

import { TASKS_GRID_FIELD_HAS_VALUE_SR_LABEL } from 'constants/uiConstants';
import MergeClassNames from 'utils/MergeClassNames';

// Shows and hides one Application Details field (OP-2534). Hiding keeps the
// value — clearing is a separate action beside the field — so the icon is a
// minus, not a "×" that would read as delete. A hidden field that holds a
// value keeps a dot, so it's never lost from view.
const FIELD_TOGGLE_BASE_CLASS =
  'inline-flex flex-shrink-0 items-center gap-1 rounded-[var(--radius-button)] border border-solid px-2 py-1 text-xs font-semibold transition-colors';
const FIELD_TOGGLE_INACTIVE_CLASS =
  'border-gray-argent bg-white text-secondary-dark hover:bg-secondary';
const FIELD_TOGGLE_ACTIVE_CLASS =
  'border-gray-dark bg-gray-dark text-white hover:bg-gray-dark/90';

interface FieldTogglePillProps {
  label: string;
  isActive: boolean;
  /** The field holds a value (shown as a dot while the field is hidden). */
  hasValue?: boolean;
  onToggle: () => void;
}

const FieldTogglePill: React.FC<FieldTogglePillProps> = ({
  label,
  isActive,
  hasValue = false,
  onToggle,
}) => (
  <button
    type="button"
    aria-pressed={isActive}
    className={MergeClassNames(
      FIELD_TOGGLE_BASE_CLASS,
      isActive ? FIELD_TOGGLE_ACTIVE_CLASS : FIELD_TOGGLE_INACTIVE_CLASS
    )}
    onClick={(event) => {
      event.stopPropagation();
      onToggle();
    }}
  >
    {isActive ? <FaMinus size={9} /> : <FaPlusSolid size={9} />}
    {label}
    {!isActive && hasValue && (
      <>
        <span
          aria-hidden="true"
          className="h-1.5 w-1.5 rounded-full bg-secondary-dark"
        />
        <span className="sr-only">{TASKS_GRID_FIELD_HAS_VALUE_SR_LABEL}</span>
      </>
    )}
  </button>
);

export default FieldTogglePill;
